(function ($) {
    function getContainer() {
        return $('#architect-contacts-container');
    }

    function getForm() {
        return $('#IndividualForm').length ? $('#IndividualForm') : $('form').first();
    }

    function reparseValidation() {
        const $form = getForm();

        if ($form.length === 0 || !$.validator || !$.validator.unobtrusive) {
            return;
        }

        $form.removeData('validator');
        $form.removeData('unobtrusiveValidation');
        $.validator.unobtrusive.parse($form);
    }

    function refreshDeleteButtons() {
        const $container = getContainer();

        if ($container.length === 0) {
            return;
        }

        const $items = $container.find('.architect-contact-item');

        $items.each(function (index) {
            const $item = $(this);
            const $existingDeleteRow = $item.find('.js-delete-contact-row');

            if (index === 0) {
                $existingDeleteRow.remove();
                return;
            }

            if ($existingDeleteRow.length === 0) {
                $item.append(
                    '<div class="form-row js-delete-contact-row">' +
                    '<button type="button" class="button js-delete-architect-contact">Delete contact</button>' +
                    '</div>'
                );
            }
        });
    }

    function generateKey() {
        if (window.crypto && typeof window.crypto.randomUUID === 'function') {
            return window.crypto.randomUUID().replace(/-/g, '');
        }

        return 'contact_' + new Date().getTime() + '_' + Math.floor(Math.random() * 100000);
    }

    function addContact() {
        const $container = getContainer();

        if ($container.length === 0) {
            return;
        }

        const key = generateKey();

        $.ajax({
            url: `/umbraco/surface/JoinForm/GetArchitectContact?prefix=${key}`,
            type: 'GET',
            success: function (html) {
                $container.append(html);

                refreshDeleteButtons();
                reparseValidation();
            },
            error: function () {
                console.error('Failed to load contact template');
            }
        });
    }

    function deleteContact(button) {
        const $item = $(button).closest('.architect-contact-item');

        if ($item.length === 0) {
            return;
        }

        $item.remove();

        refreshDeleteButtons();
        reparseValidation();
    }

    function initializeArchitectContacts() {
        if (getContainer().length === 0) {
            return;
        }

        refreshDeleteButtons();
        reparseValidation();
    }

    $(document).on('click', '#add-architect-contact', function (e) {
        e.preventDefault();
        addContact();
    });

    $(document).on('click', '.js-delete-architect-contact', function (e) {
        e.preventDefault();
        deleteContact(this);
    });

    $(document).on('content:practice-loaded', function () {
        initializeArchitectContacts();
    });

    $(function () {
        initializeArchitectContacts();
    });
})(jQuery);
